import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
  ModalItem,
  Form,
  FormItem,
  InputItem,
  InputNumberItem,
  HeaderItem,
  BoxItem,
  ButtonItem,
  TextAreaItem,
} from "../../../../Components/Items";
import { Row, Col, message } from "antd";
import SelectProyectosItem from "../../../../Components/SelectProyectosItem";

class AgregarUbicacion extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      // Precarga el almacén ya seleccionado en la pantalla (si había uno), pero
      // siempre queda editable dentro del modal.
      const valoresIniciales = { proyectoId: this.props.proyectoId };
      if (this.props.rackMode) {
        if (this.props.columna != null) valoresIniciales.columna = this.props.columna;
        if (this.props.nivelRack != null) valoresIniciales.nivelRack = this.props.nivelRack;
        if (this.props.profundidad != null) valoresIniciales.profundidad = this.props.profundidad;
      }
      this.formRef.current?.setFieldsValue(valoresIniciales);
    }
  }

  atras() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  onFinishFailed(e) {
    message.error("Verifica los campos obligatorios.");
  }

  onFinish(values) {
    this.setState({ loading: true });
    // En modo rack (abierto desde el drawer de un rack en la pantalla Mapa - ver RackDetalleDrawer.js) el
    // almacén/rack/nodo de acceso ya se conocen por contexto y no se piden en el formulario.
    const datosRack = this.props.rackMode
      ? { proyectoId: this.props.proyectoId, rackId: this.props.rackId, nodoAccesoId: this.props.nodoAccesoId }
      : {};
    axios
      .post(
        "ubicacionProyecto/agregarUbicacionProyecto",
        {
          ...values,
          ...datosRack,
          empresaId: this.props.empresaId,
          usuarioId: this.props.usuarioId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Ubicación registrada correctamente");
          this.formRef.current.resetFields();
          if (this.props.onClose) this.props.onClose(res.data.ubicacionId);
        } else {
          message.error(res.data.message || "No se pudo registrar la ubicación");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al registrar la ubicación");
      });
  }

  render() {
    return (
      <ModalItem
        title="Agregar Ubicación"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.atras.bind(this)}
        paddingTop
        width={950}
      >
        <Form
          ref={this.formRef}
          name="agregarUbicacion"
          layout
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Guardar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <HeaderItem>DATOS DE LA UBICACIÓN</HeaderItem>
            <BoxItem>
              <Row gutter={16}>
                {!this.props.rackMode && (
                  <Col span={24}>
                    <FormItem
                      label="Almacén"
                      name="proyectoId"
                      required
                      margin
                    >
                      <SelectProyectosItem
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        width="100%"
                        placeholder="Almacén"
                      />
                    </FormItem>
                  </Col>
                )}
                <Col span={12}>
                  <FormItem
                    label="Clave"
                    name="clave"
                    required
                    margin
                  >
                    <InputItem placeholder="Clave" />
                  </FormItem>
                  <FormItem
                    label="Nombre"
                    name="nombre"
                    required
                    margin
                  >
                    <InputItem placeholder="Nombre" />
                  </FormItem>
                  <FormItem
                    label="Descripción"
                    name="descripcion"
                    margin
                  >
                    <TextAreaItem placeholder="Descripción" />
                  </FormItem>
                  {!this.props.rackMode && (
                    <>
                      <FormItem
                        label="Secuencia"
                        name="secuencia"
                        margin
                        numberCero
                      >
                        <InputNumberItem placeholder="Secuencia" />
                      </FormItem>
                      <FormItem
                        label="Secuencia Recorrido"
                        name="secuenciaRecorrido"
                        margin
                        number
                      >
                        <InputNumberItem placeholder="Secuencia Recorrido" />
                      </FormItem>
                    </>
                  )}
                  <FormItem
                    label="Cantidad Máxima"
                    name="cantidadMaxima"
                    margin
                    numberCero
                  >
                    <InputNumberItem placeholder="Cantidad Máxima" />
                  </FormItem>
                </Col>
                <Col span={12}>
                  <FormItem
                    label="Ancho"
                    name="ancho"
                    margin
                    numberCero
                    tooltip="La medida esta en metros."
                  >
                    <InputNumberItem placeholder="Ancho (mts)" />
                  </FormItem>
                  <FormItem
                    label="Alto"
                    name="alto"
                    margin
                    numberCero
                    tooltip="La medida esta en metros."
                  >
                    <InputNumberItem placeholder="Alto (mts)" />
                  </FormItem>
                  <FormItem
                    label="Largo"
                    name="largo"
                    margin
                    numberCero
                    tooltip="La medida esta en metros."
                  >
                    <InputNumberItem placeholder="Largo (mts)" />
                  </FormItem>

                  {!this.props.rackMode && (
                    <FormItem
                      label="Número Rack"
                      name="numeroRack"
                      margin
                      numberCero
                    >
                      <InputNumberItem placeholder="Número Rack" />
                    </FormItem>
                  )}

                  {this.props.rackMode && (
                    <FormItem
                      label="Columna"
                      name="columna"
                      margin
                      numberCero
                    >
                      <InputNumberItem placeholder="Columna" />
                    </FormItem>
                  )}

                  <FormItem
                    label="Nivel Rack"
                    name="nivelRack"
                    margin
                    numberCero
                  >
                    <InputNumberItem placeholder="Nivel Rack" />
                  </FormItem>

                  {this.props.rackMode && (
                    <FormItem
                      label="Profundidad"
                      name="profundidad"
                      margin
                      numberCero
                    >
                      <InputNumberItem placeholder="Profundidad" />
                    </FormItem>
                  )}

                  <FormItem
                    label="Observaciones"
                    name="observaciones"
                    margin
                  >
                    <TextAreaItem placeholder="Observaciones" />
                  </FormItem>
                </Col>
              </Row>
            </BoxItem>
          </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa?.id,
});

export default connect(mapStateToProps)(AgregarUbicacion);
